module.exports = __webpack_public_path__ + "img/mt.6b89cf10.svg";